import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PropertyService {

  constructor(private http:HttpClient) { }


  
getHammaddeler(){
  return this.http.get<any[]>(environment.apiUrl+"property");
}



addHammadde(model:any){
return this.http.post(environment.apiUrl+"property",model);
}

editHammadde(model:any,id:any){
  return this.http.put(environment.apiUrl+"property/"+id,model);
  }

deleteHammadde(id:any){
  return this.http.delete(environment.apiUrl+"property/"+id);
  }
  
}
